<form [formGroup]="formGroup"
    [class]="data.isMobile?'h-full w-screen':'h-[90vh] md:h-[90vh] md:max-h-[100vh] 4xl:h-fit 4xl:max-h-[80vh] md:w-[80vw] 4xl:max-w-7xl'"
    class="flex flex-col m-auto text-darkMode-700 dark:text-darkMode-100 bg-lightCardBG dark:bg-darkCardBG relative py-3 px-3 max-h-full">
    <div class="w-full flex justify-end items-center">
        <button matRipple [mat-dialog-close]="data.selectedItem"
            class="w-8 h-8 flex items-center justify-center rounded-full overflow-hidden">
            <mat-icon class="mat-center">
                arrow_back
            </mat-icon>
        </button>
    </div>
    <input formControlName="control"
        [placeholder]="type=='organ'? 'مثال: سازمان انرژی اتمی' :type=='work_field'? 'مثال: نانو': type=='city'? 'مثال: تهران' : type=='language' ? 'مثال: English' : type=='school' ? 'مثال: دانشگاه تهران' : type=='field' ? 'مثال: مهندسی مکانیک':'' "
        maxlength="100" type="text"
        class="w-full m-0 mt-3 py-2 md:py-3 px-4 text-inherit rounded-full outline-0 border-none bg-lightBG dark:bg-darkBG valid h-[40px] md:h-[45px]">
    <div *ngIf="items"
        class="w-full border-t border-lightMode-400 dark:border-darkMode-700 mt-3 pt-3 overflow-y-auto">
        <div *ngIf="!items.length" class="w-full text-center">
            موردی یافت نشد
        </div>
        <div *ngFor="let item of items;let i = index;"
            class="flex items-center w-full p-2 cursor-pointer transition-colors ease-in-out duration-150 hover:bg-gray-500 hover:text-white bg-opacity-30 border-lightMode-200 dark:border-darkMode-700"
            [class]="i<items.length-1?'border-b mb-1':''"
            [mat-dialog-close]="item">
            <div *ngIf="this.data.type == 'school'"
                class="w-10 h-10 flex items-center justify-center overflow-hidden rounded-md ml-3 dark:bg-darkMode-100 p-1">
                <img [src]="item.logo" [alt]="item.name"
                    class="min-w-full min-h-full object-cover">
            </div>
            <span *ngIf="type!='city' && type!='language'">{{item.name}}</span>
            <span *ngIf="type=='city'">{{item.name}}، {{item.province}}،
                {{item.country}}</span>
            <span *ngIf="type=='language'">{{item.name}}
                ({{item.native_name}})</span>
        </div>
    </div>
</form>
